import {UserProfile} from "@portbase/bezoekschip-service-typescriptmodels";
import {Injectable} from '@angular/core';

declare var Beamer;

@Injectable({
  providedIn: 'root',
})
export class BeamerService {
  standardFilters = ["all", "pcs"];
  initialized = false;
  private currentFilter = "melding-schip";

  /**
   * Initialises Beamer with the identity of the (already authenticated) user.
   *
   * This must only be called once the user is actually known. Beamer is configured with
   * `lazy: true` (see assets/js/beamer.js), so it never starts on its own; the first
   * `Beamer.update(...)` call below is what boots it. Booting it with the user_id already
   * set guarantees the visitor is identified instead of being registered as an anonymous
   * (unknown) user.
   *
   * Callers must pass a profile that is guaranteed to be loaded (e.g. the one resolved by
   * the app's authentication flow). The method is idempotent, so repeated calls (such as
   * the periodic profile refresh) are harmless.
   */
  init(userProfile: UserProfile) {
    if (this.initialized || !userProfile?.iamConnectedUserId) {
      return;
    }
    Beamer.update({
      user_id: "melding-schip" + "_" + userProfile.iamConnectedUserId,
      filter: this.standardFilters.concat(this.currentFilter).join(";")
    });
    this.initialized = true;
  }

  addFilter(filter: string) {
    this.currentFilter = filter;
    if (this.initialized) {
      Beamer.update({
        filter: this.standardFilters.concat(filter).join(";")
      });
    }
  }
}
